<template>
  <div class=" col-12 mx-auto overflow-hidden">
    <h1 class="title">Kostenlose Maschinenbewertung</h1>
    <div class="flex stage-container mb3 small-border-radius">
      <div class="formstage bgcolor1">
        <p class="formstage-text passed">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z" fill="#0176CD" />
          </svg>
          <span>Ihre Branche</span>
        </p>
        <span class="gray formstage-info">{{ onboardingMachineBrancheDefault }}</span>
      </div>
      <div class="formstage bgcolor1">
        <p class="formstage-text passed">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z" fill="#0176CD" />
          </svg>
          <span>Ihre Maschine</span>
        </p>
        <span class="gray formstage-info">{{ onboardingMachineCategoryDefault }}<br />{{ onboardingManufacturerDefault }} {{ onboardingMachineTypeDefault }}</span>
      </div>
      <div class="formstage bgcolor1">
        <p class="formstage-text passed">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z" fill="#0176CD" />
          </svg>
          <span>Anschaffung</span>
        </p>
        <span class="gray formstage-info">Baujahr {{ onboardingMachineYearDefault }}<br />{{ onboardingMachineNettoPrice }}</span>
      </div>
      <div class="formstage bgcolor1">
        <p class="formstage-text passed">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z" fill="#0176CD" />
          </svg>
          <span>Ihre Kontaktdaten</span>
        </p>
        <span class="gray formstage-info">{{ onboardingCustomerEmail }}</span>
      </div>
      <div class="formstage step-background-color">
        <p class="formstage-text">5. <span>Echtzeitbewertung</span></p>
      </div>
    </div>
    <br />
    <div class="container">
      <div class="email-notification-box" style="margin-bottom: 0;">
        <h2 class="notification-title">Einzelbewertung erforderlich</h2>
        <h1 class="notification-title-2">
          Vielen Dank für Ihre Anfrage.
        </h1>
        <p class="notification-text max-width-3">{{ stripHtml(requestBlocked ? requestBlockedText : defaultText) }}</p>
      </div>
      <div class="button-flexbox align-center">
        <a class="btn std center white relative" v-on:click="resetOnboardingFormular()">
          <span class="relative z4">Weitere Maschine bewerten</span>
        </a>
      </div>
    </div>
    <div class="mb4"></div>
    <cta-support-element />
  </div>
</template>

<script>
import CTASupportElement from "./CTASupportElement.vue";
import { EventBus } from "@/event-bus.js";
export default {
  name: "OnboardingStep05",
  props: {
    name: String,
    event_name: String,
    button_style: String,
    onboardingMachineBrancheDefault: String,
    onboardingMachineCategoryDefault: String,
    onboardingManufacturerDefault: String,
    onboardingMachineTypeDefault: String,
    onboardingMachineYearDefault: String,
    onboardingMachineNettoPrice: String,
    onboardingCustomerEmail: String,
    requestBlocked: Boolean,
    requestBlockedText: Boolean,
  },
  data() {
    return {
      debug: true,
      defaultText: "Bedauerlicherweise können wir keine automatische Bewertung vornehmen. Wir werden uns zeitnah mit Ihnen in Verbindung setzen, um eine individuelle Bewertung und ein weiteres mögliches Vorgehen zu besprechen. Sollten Sie noch Fragen haben, kontaktieren Sie uns gern telefonisch.",
    };
  },
  created() {},
  components: {
    "cta-support-element": CTASupportElement,
  },
  methods: {
    log: function(obj) {
      if (this.debug) {
        console.log(obj);
      }
    },
    resetOnboardingFormular: function() {
      EventBus.$emit("evaluateNewMachine", {});
    },
    stripHtml(html) {
      // Create a temporary div element to decode HTML entities
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
  },
};
</script>
